import { parseISO } from 'date-fns'

export default parseISO
